import { render, staticRenderFns } from "./DeliveryListGenerator.vue?vue&type=template&id=7f0267ba&scoped=true"
import script from "./DeliveryListGenerator.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliveryListGenerator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DeliveryListGenerator.vue?vue&type=style&index=0&id=7f0267ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0267ba",
  null
  
)

export default component.exports